import { defineMessages } from 'react-intl';

export const pricingMessages = defineMessages({
  tierStarter: {
    id: 'Pricing.Tier.Starter',
    defaultMessage: 'Starter',
  },
  tierStarterDescription: {
    id: 'Pricing.Tier.Starter.Description',
    defaultMessage: 'Core NPS surveys for small teams. 6 months data retention.',
  },
  tierGrowth: {
    id: 'Pricing.Tier.Growth',
    defaultMessage: 'Growth',
  },
  tierGrowthDescription: {
    id: 'Pricing.Tier.Growth.Description',
    defaultMessage:
      'Advanced targeting, logic, integrations, and auto-translate. 2 years data retention.',
  },
  tierScale: {
    id: 'Pricing.Tier.Scale',
    defaultMessage: 'Scale',
  },
  tierScaleDescription: {
    id: 'Pricing.Tier.Scale.Description',
    defaultMessage:
      'Enterprise security, audit, auto-tagging, and SMS. 3 years data retention, customizable.',
  },
  featureCoreSurveys: {
    id: 'Pricing.TierFeature.CoreSurveys',
    defaultMessage: 'Core NPS, CSAT & CES surveys',
  },
  featureUnlimitedSurveys: {
    id: 'Pricing.TierFeature.UnlimitedSurveys',
    defaultMessage: 'Unlimited surveys',
  },
  featureEmailWebLink: {
    id: 'Pricing.TierFeature.EmailWebLink',
    defaultMessage: 'Email, web & link channels',
  },
  featureBasicCustomization: {
    id: 'Pricing.TierFeature.BasicCustomization',
    defaultMessage: 'Survey customization',
  },
  featureEverythingInStarter: {
    id: 'Pricing.TierFeature.EverythingInStarter',
    defaultMessage: 'Everything in Starter',
  },
  featureAdditionalQuestions: {
    id: 'Pricing.TierFeature.AdditionalQuestions',
    defaultMessage: 'Additional questions',
  },
  featureBranchingLogic: {
    id: 'Pricing.TierFeature.BranchingLogic',
    defaultMessage: 'Branching logic',
  },
  featureAudiencesWebTargeting: {
    id: 'Pricing.TierFeature.AudiencesWebTargeting',
    defaultMessage: 'Audiences & web targeting',
  },
  featureIntegrationsApi: {
    id: 'Pricing.TierFeature.IntegrationsApi',
    defaultMessage: 'Integrations & API',
  },
  featureAutoTranslate: {
    id: 'Pricing.TierFeature.AutoTranslate',
    defaultMessage: 'Auto-translate responses',
  },
  featureEverythingInGrowth: {
    id: 'Pricing.TierFeature.EverythingInGrowth',
    defaultMessage: 'Everything in Growth',
  },
  featureSso: {
    id: 'Pricing.TierFeature.SSO',
    defaultMessage: 'SSO & domain verification',
  },
  featureAuditLog: {
    id: 'Pricing.TierFeature.AuditLog',
    defaultMessage: 'Audit log',
  },
  featureAutoTagging: {
    id: 'Pricing.TierFeature.AutoTagging',
    defaultMessage: 'Auto-tagging',
  },
  featureSms: {
    id: 'Pricing.TierFeature.SMS',
    defaultMessage: 'SMS surveys',
  },
  featureCustomRetention: {
    id: 'Pricing.TierFeature.CustomRetention',
    defaultMessage: 'Custom data retention',
  },
  featureDataRetention6Months: {
    id: 'Pricing.TierFeature.DataRetention6Months',
    defaultMessage: '6 months data retention',
  },
  featureDataRetention2Years: {
    id: 'Pricing.TierFeature.DataRetention2Years',
    defaultMessage: '2 years data retention',
  },
  featureDataRetention3Years: {
    id: 'Pricing.TierFeature.DataRetention3Years',
    defaultMessage: '3 years data retention',
  },
  selectPlan: {
    id: 'Pricing.Select',
    defaultMessage: 'Select Plan',
  },
  getStarted: {
    id: 'Nav.GetStarted',
    defaultMessage: 'Free trial',
  },
  volumeUnlimited: {
    id: 'Pricing.Volume.Unlimited',
    defaultMessage: 'Unlimited',
  },
});

/** Lookup by catalog i18n id string → message descriptor (babel extracts via defineMessages). */
export const pricingMessageById = {
  'Pricing.Tier.Starter': pricingMessages.tierStarter,
  'Pricing.Tier.Starter.Description': pricingMessages.tierStarterDescription,
  'Pricing.Tier.Growth': pricingMessages.tierGrowth,
  'Pricing.Tier.Growth.Description': pricingMessages.tierGrowthDescription,
  'Pricing.Tier.Scale': pricingMessages.tierScale,
  'Pricing.Tier.Scale.Description': pricingMessages.tierScaleDescription,
  'Pricing.TierFeature.CoreSurveys': pricingMessages.featureCoreSurveys,
  'Pricing.TierFeature.UnlimitedSurveys': pricingMessages.featureUnlimitedSurveys,
  'Pricing.TierFeature.EmailWebLink': pricingMessages.featureEmailWebLink,
  'Pricing.TierFeature.BasicCustomization': pricingMessages.featureBasicCustomization,
  'Pricing.TierFeature.EverythingInStarter': pricingMessages.featureEverythingInStarter,
  'Pricing.TierFeature.AdditionalQuestions': pricingMessages.featureAdditionalQuestions,
  'Pricing.TierFeature.BranchingLogic': pricingMessages.featureBranchingLogic,
  'Pricing.TierFeature.AudiencesWebTargeting': pricingMessages.featureAudiencesWebTargeting,
  'Pricing.TierFeature.IntegrationsApi': pricingMessages.featureIntegrationsApi,
  'Pricing.TierFeature.AutoTranslate': pricingMessages.featureAutoTranslate,
  'Pricing.TierFeature.EverythingInGrowth': pricingMessages.featureEverythingInGrowth,
  'Pricing.TierFeature.SSO': pricingMessages.featureSso,
  'Pricing.TierFeature.AuditLog': pricingMessages.featureAuditLog,
  'Pricing.TierFeature.AutoTagging': pricingMessages.featureAutoTagging,
  'Pricing.TierFeature.SMS': pricingMessages.featureSms,
  'Pricing.TierFeature.CustomRetention': pricingMessages.featureCustomRetention,
  'Pricing.TierFeature.DataRetention6Months': pricingMessages.featureDataRetention6Months,
  'Pricing.TierFeature.DataRetention2Years': pricingMessages.featureDataRetention2Years,
  'Pricing.TierFeature.DataRetention3Years': pricingMessages.featureDataRetention3Years,
  'Pricing.Select': pricingMessages.selectPlan,
  'Nav.GetStarted': pricingMessages.getStarted,
  'Pricing.Volume.Unlimited': pricingMessages.volumeUnlimited,
};

export const formatPricingMessage = (intl, messageId, fallback) => {
  const descriptor = pricingMessageById[messageId];
  if (descriptor) {
    return intl.formatMessage(descriptor);
  }
  return fallback || messageId;
};
